export default __webpack_public_path__ + "static/media/1_5.cfcdd155.png";